module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/magazine/section02_08_american-village-23fea4ee065c0a5805e48c26e1ff04a2.jpg";